'use client'

import * as React from 'react'
import { industryCreatives } from '@/lib/copy/industry-creatives'
import { IndustryShoppableCreative } from './industry-shoppable-creative'

type LayoutDir = 'reel' | 'pdp'

export function IndustryCreativeCarousel() {
  const [active, setActive] = React.useState(0)
  const [layout, setLayout] = React.useState<LayoutDir>('reel')
  const creative = industryCreatives[active]

  return (
    <div className="space-y-4">
      {/* Industry tabs — numbered, horizontally scrollable */}
      <div className="no-scrollbar flex gap-2 overflow-x-auto pb-1">
        {industryCreatives.map((ind, i) => (
          <button
            key={ind.slug}
            onClick={() => setActive(i)}
            className={[
              'shrink-0 rounded-full px-4 py-1.5 text-sm font-semibold transition-colors',
              active === i
                ? 'bg-[#C8FF52] text-[#0F1419]'
                : 'bg-secondary text-muted-foreground hover:text-foreground',
            ].join(' ')}
          >
            <span className="mr-1.5 font-normal opacity-60">{ind.no} ·</span>
            {ind.name}
          </button>
        ))}
      </div>

      {/* Layout direction toggle — carousel-level, persists across tabs */}
      <div className="flex items-center gap-3">
        <span className="text-[11px] font-semibold uppercase tracking-widest text-muted-foreground">Layout direction</span>
        <div className="flex rounded-full border bg-secondary p-[3px]">
          {([['reel', 'Reel · Social'], ['pdp', 'On-site · PDP']] as [LayoutDir, string][]).map(([val, label]) => (
            <button
              key={val}
              onClick={() => setLayout(val)}
              className={[
                'rounded-full px-4 py-1.5 text-xs font-semibold transition duration-200',
                layout === val
                  ? 'bg-foreground text-background shadow-sm'
                  : 'text-muted-foreground hover:text-foreground',
              ].join(' ')}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* Creative panel — keyed by slug so it remounts + replays on tab switch */}
      <IndustryShoppableCreative
        key={creative.slug}
        creative={creative}
        layoutDir={layout}
        hideToggle
      />
    </div>
  )
}
